export default __webpack_public_path__ + "static/media/country.b3d3d447.svg";